import { render, staticRenderFns } from "./ActionAssignees.vue?vue&type=template&id=028716df"
import script from "./ActionAssignees.vue?vue&type=script&lang=js"
export * from "./ActionAssignees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports